import { serviceGroups } from '@/mocks/projects';
import { Link } from 'react-router-dom';

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-cream-50">
      <div className="pt-32 pb-12 md:pt-40 md:pb-16 max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
        <p className="font-mono text-xs text-stone-400 tracking-[0.25em] uppercase mb-5 whitespace-nowrap">
          What We Offer
        </p>
        <h1 className="font-serif text-5xl md:text-7xl text-charcoal-900 mb-6">
          Building Design Services
        </h1>
        <p className="text-stone-500 text-base max-w-xl leading-relaxed">
          Building design, interiors, planning coordination, project management, branding and digital — connected by one Melbourne team.
        </p>
      </div>

      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 pb-28">
        <div className="space-y-0">
          {serviceGroups.map((group, idx) => (
            <div
              key={group.title}
              className={`group grid grid-cols-1 lg:grid-cols-12 gap-0 border-b border-stone-200/60 last:border-b-0 ${
                idx % 2 === 0 ? '' : ''
              }`}
            >
              <div className={`lg:col-span-5 relative w-full aspect-[4/3] lg:aspect-auto overflow-hidden ${
                idx % 2 === 1 ? 'lg:order-2' : ''
              }`}>
                <div
                  className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-editorial group-hover:scale-105"
                  style={{ backgroundImage: `url('${group.imageUrl}')` }}
                />
                <div className="absolute inset-0 bg-charcoal-900/10 group-hover:bg-charcoal-900/5 transition-colors duration-500"></div>
                <div className="absolute top-6 left-6">
                  <span className="font-mono text-[11px] text-cream-50/80 tracking-[0.3em] uppercase bg-charcoal-900/35 backdrop-blur-sm px-3 py-1.5 whitespace-nowrap">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                </div>
              </div>

              <div className={`lg:col-span-7 py-12 md:py-16 px-0 lg:px-16 ${
                idx % 2 === 1 ? 'lg:order-1 lg:text-right' : ''
              }`}>
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-9 h-9 flex items-center justify-center">
                    <i className={`${group.icon} text-xl text-terracotta-500`}></i>
                  </div>
                  <span className="font-mono text-[10px] text-stone-400 tracking-[0.3em] uppercase whitespace-nowrap">
                    Service {String(idx + 1).padStart(2, '0')}
                  </span>
                </div>

                <h2 className="font-serif text-3xl md:text-4xl text-charcoal-900 mb-5 leading-tight tracking-tight">
                  {group.title}
                </h2>

                <p className="text-base text-stone-500 leading-relaxed mb-7 max-w-lg">
                  {group.intro}
                </p>

                <div className={`w-12 h-[2px] bg-terracotta-400 mb-8 ${idx % 2 === 1 ? 'lg:ml-auto' : ''}`} />

                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3.5">
                  {group.items.map((item) => (
                    <li
                      key={item}
                      className="flex items-start gap-3 text-sm text-stone-600 leading-relaxed group/item"
                    >
                      <span className="mt-1.5 w-1.5 h-1.5 bg-terracotta-400/60 shrink-0 transition-all duration-300 group-hover/item:bg-terracotta-500" />
                      <span className="transition-colors duration-300 group-hover/item:text-charcoal-800">{item}</span>
                    </li>
                  ))}
                </ul>
                {group.path && (
                  <Link to={group.path} className="inline-flex items-center gap-2 mt-8 text-sm text-terracotta-600 hover:text-terracotta-700">
                    Explore {group.title.toLowerCase()} <span aria-hidden="true">→</span>
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="relative py-20 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-fixed"
          style={{
            backgroundImage: "url('/images/cta-background.webp')",
          }}
        />
        <div className="absolute inset-0 bg-charcoal-900/80"></div>
        <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 text-center">
          <h2 className="font-serif text-3xl md:text-4xl text-cream-50 mb-6">
            Ready to discuss your project?
          </h2>
          <p className="text-stone-400 text-base mb-8 max-w-lg mx-auto">
            From site assessment through to settlement — we're with you at every stage.
          </p>
          <a
            href="/contact"
            className="inline-block px-10 py-4 bg-terracotta-500 text-cream-50 text-sm font-medium tracking-wider uppercase hover:bg-terracotta-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Get in Touch
          </a>
        </div>
      </div>
    </div>
  );
}
